import React,{ useState, useEffect, useMemo} from 'react';
import '../assets/scss/main.scss';
import DashboardSideBar from '../Components/DashboardSideBar'
import { useHistory } from 'react-router-dom';
import { Dropdown, Spinner } from 'react-bootstrap'  
import { useSelector, useDispatch } from "react-redux";
import SweetAlert from 'react-bootstrap-sweetalert';
import io from 'socket.io-client';
import { HASTRA_IMAGE_URI, SOCKET_PATH, HUSTRA_CHAT_URI } from '../Config/Config' 
import { Badge } from 'antd';
function MainLayout(props) {  

    const {apiLoader, loginData, socketData, chatUserIdData, messageData} = useSelector(state => state);   
    const dispatch = useDispatch()
    const history = useHistory()

    const [showDialog, setShowDialog] = useState(false)
    
     
    useEffect(() => {   
            if (socketData.length === 0) {
                
            if(localStorage.getItem('doctor_jwt_token')){ 
                    // socket = io.connect(HUSTRA_CHAT_URI)
                    let socket;
                    socket = io.connect(HUSTRA_CHAT_URI, {
                                    'path': SOCKET_PATH,
                                    forceNode: true,
                                }); 

                    socket.on("doctor-receive-message-"+loginData._id, (receiveMsgData) => {  

                            let data = {
                               msg: receiveMsgData,
                               socket: socket 
                            }
                            dispatch({
                                type: 'MESSAGE_RECEIVED',
                                payload: data
                            }); 

                            var element = document.getElementById("messageEndBox");
                            if(element != undefined){
                                element.scrollIntoView({ behavior: 'smooth' })
                            } 
                    })
                    
                    dispatch({
                        type: 'STORE_SOCKET',
                        payload: socket
                    }); 
             
            }
        } 
        
        return ( () => {
            if (socketData.length > 0) {
                socketData.disconnect() 
                dispatch({ type: 'DELETE_SOCKET'}); 
            }
        }) 
        
    }, []);


    const messageCountShow = useMemo(
        () => {
            if(messageData.length > 0){
                let filterMessage = messageData.filter( (item) => { return (item.readAt === undefined && item.send_by === "patient") })  
               return filterMessage.length
            }else{
                return 0;
            }
            
      });

  



    let toggleSideBar = () => {
        let bodyElement = document.getElementsByTagName("BODY")[0];
        bodyElement.classList.toggle("sidebar-open"); 
    }

    let signOut = () => {
        setShowDialog(true)
    }

    let sweetAltertCancel = ()  => {
        setShowDialog(false)
    }

    let sweetAltertConfirm = ()  => {
        setShowDialog(false)
        localStorage.removeItem('doctor_user_details')
        localStorage.removeItem('doctor_jwt_token') 
        // history.push("/");
        window.location.href="/"
    }


    return (  
            <>
                {
                        (showDialog) ?  <SweetAlert warning showCancel confirmBtnText="Yes" confirmBtnBsStyle="danger" title="Are you sure?" onConfirm={sweetAltertConfirm} onCancel={sweetAltertCancel} focusCancelBtn> Do you want logout </SweetAlert>
                        :
                        null
                }
                {
                    (apiLoader) ?
                    <div className="loader-container">
                            <Spinner animation="border" variant="secondary" /> 
                    </div>
                    :
                    null
                }

                <div className="wrapper"> 
                    <header className="main-header">

                        <a className="logo">
                            <img src={ require('../assets/images/logo_final.png') }/>
                        </a> 

                        <nav className="navbar navbar-static-top"> 
                        <a onClick={toggleSideBar} className="sidebar-toggle" data-toggle="push-menu" role="button">
                            <i className="fa fa-bars" aria-hidden="true"></i> 
                        </a>

                        <div className="navbar-custom-menu ">
                            <ul className="nav navbar-nav right-bar-menu">

                            <li class="notifications-menu"> 
                                
                                <Badge style={{backgroundColor: '#f44336', borderColor: '#f44336' }} count={messageCountShow} offset={[0, 0]}> <i class="fa fa-bell"></i>  </Badge>
                                {/* <span className="label label-warning message-count-show" id="messageCount">{messageCountShow}</span> */}
                             </li>

                            <li className="dropdown user user-menu">
                            <Dropdown>
                                <Dropdown.Toggle className="dropdown-toggle header-drop-menu"  id="dropdown-basic">
                                            <span className="hidden-xs">Hi {loginData.first_name} {loginData.last_name}</span>
                                            <img src={ (loginData.picture) ? HASTRA_IMAGE_URI+loginData.picture : require('../assets/images/user2-160x160.jpg') } className="user-image" alt="User Image"/>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="dropdown-menu">
                                <li className="user-header">
                                            <img src={ (loginData.picture) ? HASTRA_IMAGE_URI+loginData.picture : require('../assets/images/user2-160x160.jpg') } className="img-circle" alt="User Image"/> 
                                            <p>
                                            {loginData.first_name} {loginData.last_name} 
                                            </p>
                                        </li> 
                                        {/* <!-- Menu Footer--> */}
                                        <li className="user-footer">
                                            <div className="pull-left">
                                            
                                            </div>
                                            <div className="pull-right"> 
                                                        <button type="submit" className="btn btn-default btn-flat" onClick={signOut}><i className="ti-power-off mr-0-5"></i> Sign out </button> 
                                            </div>
                                        </li>
                                </Dropdown.Menu>
                                </Dropdown>
                            </li>
                            
                            </ul>
                        </div>
                        </nav>
                    </header>

                    <DashboardSideBar/>
                    
                    <div className="content-wrapper">  
                        <section className="content">  

                            {props.children}  

                        </section>  
                    </div>
            </div>
        </>
      );
}
  
export default MainLayout;